/**
 * Money formatting utilities for TCSB.
 *
 * All monetary values from the API are INT cents (CON-001 §7, CON-002 §11).
 * NEVER divide by 100 inline — always use formatCents().
 */

/**
 * Formats an integer cent value to a USD display string.
 * @param {number} cents - Integer cents value (e.g. 450)
 * @returns {string} Formatted string (e.g. "$4.50")
 * @example
 * formatCents(0)     // "$0.00"
 * formatCents(100)   // "$1.00"
 * formatCents(450)   // "$4.50"
 * formatCents(12345) // "$123.45"
 */
export const formatCents = (cents) => {
  if (cents == null || isNaN(cents)) return "$0.00";
  return `$${(cents / 100).toFixed(2)}`;
};
